/* ============================================
   QN-NEW CART DRAWER JS
   COMPLETO
   ============================================ */

(function () {
  'use strict';

  const QNCartDrawer = {
    FREE_SHIPPING_THRESHOLD: 2500,
    HUEVOS_PROMO_PROP: '_qn_huevos_promo',
    HUEVOS_PROMO_VALUE: '200',
    HUEVOS_VARIANT_PROMO: '52372967162132',
    HUEVOS_VARIANT_PROMO_YUMBO: '52373004353812',
    HUEVOS_VARIANT_REGULAR: '52244565262612',
    HUEVOS_VARIANT_REGULAR_YUMBO: '52347242742036',

    LOCKED_PRODUCT_ID: '10154045407508',
    LOCKED_VARIANT_ID: '52244579909908',

    init: function () {
      this.cacheElements();
      this.bindEvents();
      this.fetchCart();
      this.updateHeaderCount(this.getInitialHeaderCount());
    },

    cacheElements: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-overlay]');
      this.container = document.querySelector('.qn-cart-drawer__container');
      this.itemsContainer = document.querySelector('[data-cart-items]');
      this.shippingBar = document.querySelector('[data-shipping-bar]');
      this.shippingMessage = document.querySelector('[data-shipping-message]');
      this.shippingProgress = document.querySelector('[data-shipping-progress]');
      this.cartCount = document.querySelector('[data-cart-count]');
      this.cartSubtotal = document.querySelector('[data-cart-subtotal]');
      this.footer = this.drawer ? this.drawer.querySelector('.qn-cart-drawer__footer') : null;
      this.upsellWrap = this.drawer ? this.drawer.querySelector('[data-cart-upsell-wrap]') : null;
      this.huevosConfig = null;
      this.isRefreshing = false;
      this.currentCart = null;
      this.autoOpenTimer = null;
    },

    bindEvents: function () {
      document.addEventListener('qn:cart:open', this.open.bind(this));

      document.addEventListener('click', async (e) => {
        const closeBtn = e.target.closest('[data-cart-close]');
        const minusBtn = e.target.closest('[data-qty-minus]');
        const plusBtn = e.target.closest('[data-qty-plus]');
        const removeBtn = e.target.closest('[data-item-remove]');
        const openCartBtn = e.target.closest('[data-cart-trigger], .qn-header__cart');

        if (closeBtn || e.target.closest('[data-cart-overlay]')) {
          e.preventDefault();
          this.close();
          return;
        }

        if (minusBtn) {
          e.preventDefault();
          await this.updateQuantity(minusBtn.dataset.itemKey, -1);
          return;
        }

        if (plusBtn) {
          e.preventDefault();
          await this.updateQuantity(plusBtn.dataset.itemKey, 1);
          return;
        }

        if (removeBtn) {
          e.preventDefault();
          await this.removeItem(removeBtn.dataset.itemKey);
          return;
        }

        if (openCartBtn && this.drawer) {
          e.preventDefault();
          this.open();
          return;
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });

      document.addEventListener('qn:cart:updated', (e) => {
        if (e.detail && e.detail.items) {
          this.currentCart = e.detail;
          this.refreshCart(e.detail);
        } else {
          this.fetchCart(false);
        }
      });

      document.addEventListener('cart:updated', () => {
        this.fetchCart(false);
      });

      document.addEventListener('submit', (e) => {
        const form = e.target;
        if (!form.matches('form[action*="/cart/add"]')) return;
        this.scheduleAutoOpen();
      });

      document.addEventListener('click', (e) => {
        const addBtn = e.target.closest(
          'button[name="add"], .bls__js-addtocart, .product-form__submit, [data-add-to-cart]'
        );
        if (!addBtn) return;
        this.scheduleAutoOpen();
      });
    },

    scheduleAutoOpen: function () {
      clearTimeout(this.autoOpenTimer);

      this.autoOpenTimer = setTimeout(() => {
        this.fetchCart(false).then(() => {
          this.open(false);
        });
      }, 700);
    },

    getInitialHeaderCount: function () {
      const badge = document.querySelector('.qn-header__cart-count');
      if (!badge) return 0;
      return parseInt(badge.textContent.trim(), 10) || 0;
    },

    getHuevosConfig: function () {
      const source = document.querySelector('#qnHuevosUpsell');
      const dataset = source ? source.dataset : {};

      this.huevosConfig = {
        promoProp: dataset.promoProp || this.HUEVOS_PROMO_PROP,
        promoValue: dataset.promoValue || this.HUEVOS_PROMO_VALUE,
        promoProductId: String(dataset.productPromo || this.LOCKED_PRODUCT_ID),
        legacyLockedVariantId: String(dataset.variantLegacyLocked || this.LOCKED_VARIANT_ID),
        promoVariantId: String(dataset.variantPromo || this.HUEVOS_VARIANT_PROMO),
        promoYumboVariantId: String(dataset.variantPromoYumbo || this.HUEVOS_VARIANT_PROMO_YUMBO),
        regularVariantId: String(dataset.variantRegular || this.HUEVOS_VARIANT_REGULAR),
        regularYumboVariantId: String(dataset.variantRegularYumbo || this.HUEVOS_VARIANT_REGULAR_YUMBO)
      };

      return this.huevosConfig;
    },

    open: function (shouldFetch = true) {
      if (!this.drawer) return;

      this.drawer.setAttribute('aria-hidden', 'false');
      this.drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      if (shouldFetch) {
        this.fetchCart(false);
      }
    },

    close: function () {
      if (!this.drawer) return;

      this.drawer.setAttribute('aria-hidden', 'true');
      this.drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    fetchCart: function (openAfterRefresh = false) {
      if (this.isRefreshing) {
        return Promise.resolve(this.currentCart);
      }

      this.isRefreshing = true;

      return fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      })
        .then((response) => response.json())
        .then((cart) => this.normalizePromoCart(cart))
        .then((cart) => {
          this.currentCart = cart;
          this.refreshCart(cart);

          if (openAfterRefresh) {
            this.open(false);
          }

          return cart;
        })
        .catch((error) => {
          console.error('Error fetching cart:', error);
          return null;
        })
        .finally(() => {
          this.isRefreshing = false;
        });
    },

    // Un item es "maple" si pertenece al producto promo (cualquiera de sus tamaños)
    // o trae la propiedad de promo. Ya no hay variantes "regular" aparte.
    isPromoHuevosItem: function (item) {
      const config = this.getHuevosConfig();
      const productId = item && item.product_id != null ? String(item.product_id) : '';
      const hasPromoProperty = !!(
        item &&
        item.properties &&
        item.properties[config.promoProp] === config.promoValue
      );
      return productId === config.promoProductId || hasPromoProperty;
    },

    // Ya no se bloquea la cantidad a 1: el maple usa controles normales y el tope (2) lo maneja el JS.
    isLockedQtyItem: function () {
      return false;
    },

    // Cantidad total de maples en el carrito (sumando todos los tamaños).
    getMapleTotalQty: function (cart) {
      if (!cart || !cart.items) return 0;
      return cart.items.reduce((acc, item) => {
        return this.isPromoHuevosItem(item) ? acc + item.quantity : acc;
      }, 0);
    },

    findItemByKey: function (key) {
      if (!this.currentCart || !this.currentCart.items) return null;
      return this.currentCart.items.find((item) => item.key === key) || null;
    },

    normalizePromoCart: async function (cart) {
      if (!cart || !cart.items) return cart;
      if (!cart.items.length) return cart;

      // Tope: máximo 2 maples en total (sumando todos los tamaños). Sin promo/regular.
      const mapleItems = cart.items.filter((item) => this.isPromoHuevosItem(item));
      let total = mapleItems.reduce((acc, item) => acc + item.quantity, 0);

      if (total <= 2) return cart;

      // Recortar el excedente desde el último maple hasta dejar 2 en total.
      for (let idx = mapleItems.length - 1; idx >= 0 && total > 2; idx--) {
        const item = mapleItems[idx];
        const newQty = Math.max(0, item.quantity - (total - 2));

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: newQty
          })
        });

        total -= (item.quantity - newQty);
      }

      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      });
      return response.json();
    },

    updateQuantity: async function (key, change) {
      const currentItem = this.findItemByKey(key);
      if (!currentItem) return;

      // Maple: tope de 2 en total (sumando todos los tamaños). Sin variante regular.
      if (this.isPromoHuevosItem(currentItem)) {
        if (change > 0 && this.getMapleTotalQty(this.currentCart) >= 2) {
          return; // ya hay 2 maples, no se agrega más
        }
        const mapleQty = currentItem.quantity + change;
        if (mapleQty < 1) {
          await this.removeItem(key);
          return;
        }
        await this.changeItem(key, mapleQty);
        return;
      }

      const newQty = currentItem.quantity + change;

      if (newQty < 1) {
        await this.removeItem(key);
        return;
      }

      await this.changeItem(key, newQty);
    },

    changeItem: function (key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      })
        .then((response) => {
          if (!response.ok) throw new Error('Error updating cart');
          return response.json();
        })
        .then((cart) => this.normalizePromoCart(cart))
        .then((cart) => {
          this.currentCart = cart;
          this.refreshCart(cart);
          document.dispatchEvent(new CustomEvent('qn:cart:updated', { detail: cart }));
          return cart;
        })
        .catch((error) => {
          console.error('Error updating cart:', error);
          return null;
        });
    },

    removeItem: async function (key) {
      const item = this.itemsContainer
        ? this.itemsContainer.querySelector(`[data-item-key="${this.escapeSelector(key)}"]`)
        : null;

      if (item) {
        item.style.opacity = '0.5';
        item.style.pointerEvents = 'none';
      }

      const cart = await this.changeItem(key, 0);

      if (!cart || !cart.items) return cart;

      // Regla removida: el maple puede quedar solo en el carrito.
      return cart;
    },

    addItem: function (variantId, quantity = 1, properties = {}) {
      const data = {
        id: variantId,
        quantity: quantity
      };

      if (Object.keys(properties).length > 0) {
        data.properties = properties;
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then((response) => {
          if (!response.ok) throw new Error('Error adding item');
          return response.json();
        })
        .then((item) => {
          return this.fetchCart(true).then(() => {
            document.dispatchEvent(
              new CustomEvent('qn:cart:itemAdded', {
                detail: { item: item }
              })
            );
            return item;
          });
        })
        .catch((error) => {
          console.error('Error adding item:', error);
          return null;
        });
    },

    refreshCart: function (cart) {
      if (!cart) return;

      this.currentCart = cart;

      if (this.cartCount) {
        this.cartCount.textContent = `(${cart.item_count})`;
      }

      this.updateHeaderCount(cart.item_count);
      this.updateShippingBar(cart.total_price);
      this.toggleUpsell(cart);
      this.renderCartItems(cart);
      this.renderFooter(cart);
    },

    toggleUpsell: function (cart) {
      if (!this.upsellWrap) return;

      if (cart && cart.item_count > 0) {
        this.upsellWrap.style.display = '';
      } else {
        this.upsellWrap.style.display = 'none';
      }
    },

    getQtyHtml: function (item) {
      if (this.isLockedQtyItem(item)) {
        return `
          <div class="qn-cart-drawer__item-qty qn-cart-drawer__item-qty--locked">
            <span class="qn-cart-drawer__qty-locked">1</span>
          </div>
        `;
      }

      return `
        <div class="qn-cart-drawer__item-qty">
          <button type="button" class="qn-cart-drawer__qty-btn" data-qty-minus data-item-key="${this.escapeHtml(item.key)}" aria-label="Restar cantidad">−</button>
          <input
            type="text"
            value="${item.quantity}"
            inputmode="numeric"
            class="qn-cart-drawer__qty-input"
            data-qty-input
            data-item-key="${this.escapeHtml(item.key)}"
            readonly
            aria-label="Cantidad"
            tabindex="-1"
          >
          <button type="button" class="qn-cart-drawer__qty-btn" data-qty-plus data-item-key="${this.escapeHtml(item.key)}" aria-label="Sumar cantidad">+</button>
        </div>
      `;
    },

    renderCartItems: function (cart) {
      if (!this.itemsContainer) return;

      if (cart.item_count === 0) {
        this.renderEmptyCart();
        return;
      }

      this.itemsContainer.innerHTML = cart.items
        .map((item) => {
          const image = item.image
            ? `<img src="${item.image}" alt="${this.escapeHtml(item.product_title)}" loading="lazy" width="80" height="80">`
            : `<div class="qn-cart-drawer__item-placeholder"></div>`;

          const variant =
            item.variant_title && item.variant_title !== 'Default Title'
              ? `<p class="qn-cart-drawer__item-variant">${this.escapeHtml(item.variant_title)}</p>`
              : '';

          const titleHtml = this.isPromoHuevosItem(item)
            ? `<span class="qn-cart-drawer__item-title--no-link">${this.escapeHtml(item.product_title)}</span>`
            : `<a href="${item.url}">${this.escapeHtml(item.product_title)}</a>`;

          return `
            <div class="qn-cart-drawer__item" data-cart-item data-item-key="${this.escapeHtml(item.key)}">
              <div class="qn-cart-drawer__item-image">
                ${image}
              </div>

              <div class="qn-cart-drawer__item-details">
                <h3 class="qn-cart-drawer__item-title">
                  ${titleHtml}
                </h3>

                ${variant}

                <div class="qn-cart-drawer__item-bottom">
                  ${this.getQtyHtml(item)}
                  <span class="qn-cart-drawer__item-price">${this.formatMoney(item.final_line_price)}</span>
                </div>
              </div>

              <button type="button" class="qn-cart-drawer__item-remove" data-item-remove data-item-key="${this.escapeHtml(item.key)}" aria-label="Eliminar item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
          `;
        })
        .join('');
    },

    renderFooter: function (cart) {
      if (!this.container) return;

      if (!this.footer) {
        this.footer = document.createElement('div');
        this.footer.className = 'qn-cart-drawer__footer';
        this.container.appendChild(this.footer);
      }

      if (cart.item_count === 0) {
        this.footer.style.display = 'none';
        this.footer.innerHTML = '';
        return;
      }

      this.footer.style.display = '';

      this.footer.innerHTML = `
        <div class="qn-cart-drawer__subtotal">
          <span>Subtotal</span>
          <span class="qn-cart-drawer__subtotal-amount" data-cart-subtotal>${this.formatMoney(cart.total_price)}</span>
        </div>

        <p class="qn-cart-drawer__note">Envío y descuentos calculados al finalizar la compra</p>

        <a href="/checkout" class="qn-btn qn-btn-secondary qn-btn-lg qn-cart-drawer__checkout">
          Finalizar compra
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </a>

        <a href="https://quieronatural.uy/collections/all?sort_by=best-selling" class="qn-cart-drawer__continue">Seguir comprando</a>
      `;

      this.cartSubtotal = this.footer.querySelector('[data-cart-subtotal]');
    },

    renderEmptyCart: function () {
      if (!this.itemsContainer) return;

      this.itemsContainer.innerHTML = `
        <div class="qn-cart-drawer__empty">
          <div class="qn-cart-drawer__empty-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
          </div>
          <p class="qn-cart-drawer__empty-text">Tu carrito está vacío</p>
          <p class="qn-cart-drawer__empty-subtext">Agregá productos y descubrí todo lo que tenemos para vos.</p>
          <a href="https://quieronatural.uy/collections/all?sort_by=best-selling" class="qn-btn qn-btn-primary">Ver productos</a>
        </div>
      `;

      if (this.footer) {
        this.footer.style.display = 'none';
      }
    },

    updateShippingBar: function (totalCents = 0) {
      if (!this.shippingBar || !this.shippingProgress) return;

      const total = totalCents / 100;
      const remaining = Math.max(0, this.FREE_SHIPPING_THRESHOLD - total);
      const percentage = Math.max(
        0,
        Math.min(100, (total / this.FREE_SHIPPING_THRESHOLD) * 100)
      );

      this.shippingProgress.style.width = `${percentage}%`;

      if (this.shippingMessage) {
        if (total >= this.FREE_SHIPPING_THRESHOLD) {
          this.shippingMessage.innerHTML = `
            <span class="qn-cart-drawer__shipping-icon">🎉</span>
            <span>¡Ya tenés envío gratis!</span>
          `;
          this.shippingBar.classList.add('qn-cart-drawer__shipping--free');
        } else {
          this.shippingMessage.innerHTML = `
            <span class="qn-cart-drawer__shipping-icon">🚚</span>
            <span>Te faltan <strong>${this.formatMoney(remaining * 100)}</strong> para envío gratis</span>
          `;
          this.shippingBar.classList.remove('qn-cart-drawer__shipping--free');
        }
      }
    },

    updateHeaderCount: function (count) {
      const headerCounts = document.querySelectorAll('.qn-header__cart-count');
      if (!headerCounts.length) return;

      headerCounts.forEach((headerCount) => {
        headerCount.textContent = count;

        if (count > 0) {
          headerCount.classList.remove('qn-header__cart-count--empty');
          headerCount.style.display = 'inline-flex';
        } else {
          headerCount.classList.add('qn-header__cart-count--empty');
          headerCount.style.display = 'none';
        }
      });
    },

    formatMoney: function (cents) {
      const value = (Number(cents) / 100).toFixed(2);
      const parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '$' + parts[0] + ',' + parts[1];
    },

    escapeHtml: function (str) {
      if (str === null || str === undefined) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    },

    escapeSelector: function (str) {
      if (window.CSS && typeof window.CSS.escape === 'function') {
        return window.CSS.escape(str);
      }

      return String(str).replace(/"/g, '\\"');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      QNCartDrawer.init();
    });
  } else {
    QNCartDrawer.init();
  }

  window.QNCartDrawer = QNCartDrawer;
})();
